import { ROOT_STATUS } from ".";

export const STATUSES = {
  ...ROOT_STATUS,
  STATUS_DRAFT: {
    key: 'STATUS_DRAFT',
    value: 'Draft',
    color: 'secondary',
    icon: '',
  },
  STATUS_PUBLISHED: {
    key: 'STATUS_PUBLISHED',
    value: 'Published',
    color: 'primary',
    icon: '',
  },
}